import type { TechlineCommentEntity } from '@packages/domain/techline/comments';

import { useMemo } from 'react';

import { CaseCommentRow } from './case-comment-row';

/**
 * Props for the {@link CaseCommentList} component.
 */
export type CaseCommentListProps = {
    /** The list of comments to display. */
    comments?: TechlineCommentEntity[];
};

/**
 * Renders a chronologically sorted list of case comments. Each comment displays the
 * author's job title, full name, creation date, and message text.
 *
 * @param props - {@link CaseCommentListProps}
 * @returns the comment list JSX
 */
export function CaseCommentList({ comments }: CaseCommentListProps) {
    // Derived state

    /** Comments sorted chronologically by creation date (oldest first). */
    const sortedComments = useMemo(() => {
        if (!comments) {
            return [];
        }
        return comments.slice().sort((a, b) => new Date(a.createdOn).getTime() - new Date(b.createdOn).getTime());
    }, [comments]);

    return (
        <div className="ml-2 mr-3">
            {sortedComments.map((comment, index) => (
                <CaseCommentRow comment={comment} key={index} />
            ))}
        </div>
    );
}
